import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6bfe4178&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=6bfe4178&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe4178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfe4178')) {
      api.createRecord('6bfe4178', component.options)
    } else {
      api.reload('6bfe4178', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6bfe4178&scoped=true", function () {
      api.rerender('6bfe4178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/model-list-manager/Index.vue"
export default component.exports